import axiosPrivate from './axiosPrivate';

const generate = (mes, anio) => {
  return axiosPrivate.post('attendance/generate', { mes, anio });
};

const generateWeek = (start, end, macro_area = null) => {
  return axiosPrivate.post('attendance/generate-week', { start, end, macro_area });
};

const getMonthly = (usuario_id, anio, mes) => {
  return axiosPrivate.get(`attendance/${usuario_id}/${anio}/${mes}`);
};

const getMonthlyReport = (mes, anio, macro_area = null, status = '1') => {
  return axiosPrivate.get('attendance/monthly-report', { params: { mes, anio, macro_area, status } });
};

const punch = (usuario_id, timestamp = null) => {
  return axiosPrivate.post('attendance/punch', { usuario_id, timestamp });
};

const update = (payload) => {
  return axiosPrivate.post('attendance/update', payload);
};

const getEligibleUsers = (params = {}) => {
  return axiosPrivate.get('attendance/eligible-users', { params });
};

const getByDate = (fecha) => {
  return axiosPrivate.get(`attendance/by-date/${fecha}`);
};

const getConfigs = () => {
  return axiosPrivate.get('attendance-config');
};

const storeConfig = (payload) => {
  return axiosPrivate.post('attendance-config', payload);
};

const getProfiles = () => {
  return axiosPrivate.get('attendance-config/profiles');
};

const getTrackedProfiles = () => {
  return axiosPrivate.get('attendance-config/tracked-profiles');
};

const getUsersWithConfig = (perfilId) => {
  return axiosPrivate.get(`attendance-config/users-by-profile/${perfilId}`);
};

const updateTrackedProfile = (payload) => {
  return axiosPrivate.post('attendance-config/tracked-profile', payload);
};

export default {
  generate,
  getMonthly,
  punch,
  update,
  getEligibleUsers,
  generateWeek,
  getByDate,
  getMonthlyReport,
  getConfigs,
  storeConfig,
  getProfiles,
  getTrackedProfiles,
  getUsersWithConfig,
  updateTrackedProfile,
};
